// Mock data for TokoSprint clone

export const navigation = {
  logo: "Business Solution",
  menuItems: [
    { label: "Products", href: "#products", hasDropdown: true },
    { label: "Home", href: "#hero" },
    { label: "Pricing", href: "#pricing", badge: true }
  ],
  cta: "Start Now"
};

export const hero = {
  badge: "New",
  badgeText: "Welcome to TokoSprint",
  title: "Build & grow your online store effortlessly",
  subtitle: "Everything you need to launch your store in minutes.",
  cta: "Get Started",
  images: [
    "https://cdn.prod.website-files.com/6909add2e2d94f386f984495/6909b054ac74f308f11f2eaf_Team%20Image.avif",
    "https://cdn.prod.website-files.com/6909add2e2d94f386f984495/6909b10f6fc0682fbb04ccd8_Screenshot%202025-11-03%20222734.png",
    "https://cdn.prod.website-files.com/6909add2e2d94f386f984495/6909b053ac74f308f11f2df6_iPhone%2014%20Pro.png",
    "https://cdn.prod.website-files.com/6909add2e2d94f386f984495/6909b0f2df576aa7a8d2d64e_Screenshot%202025-11-04%20101504.png",
    "https://cdn.prod.website-files.com/6909add2e2d94f386f984495/6909b1513050004f070d6d76_Screenshot%202025-11-04%20145444.png",
    "https://cdn.prod.website-files.com/6909add2e2d94f386f984495/6909b054ac74f308f11f2eb8_Team%20Person%20Image%206.avif"
  ]
};

// export const partners = {
//   title: "Trusted Partners",
//   brands: [
//     { name: "Mardigu", logo: "Mardigu" },
//     { name: "Yudha Keling", logo: "Yudha Keling" },
//     { name: "Cing Abdel", logo: "Cing Abdel" },
//     { name: "Bintang Emon", logo: "Bintang Emon" },
//     { name: "MPIX By The Basecamp", logo: "MPIX By The Basecamp" },
//     { name: "PayAccess", logo: "PayAccess" }
//   ]
// };

export const partners = {
  title: "Trusted Partners",
  brands: [
    // DIUBAH: Properti 'logo' menjadi 'logoUrl' dan disetel ke null jika tidak ada URL
    { name: "Mardigu", logoUrl: "https://kontentutorialmpstore-cdn.maduraprime.com/1fbb8dd0-3de4-4162-8125-39cdb0ec294a.png" },
    { name: "Yudha Keling", logoUrl: "https://kontentutorialmpstore-cdn.maduraprime.com/ac8c4653-4d4c-46f0-a5ab-5d11c59280ea.png" },
    { name: "Cing Abdel", logoUrl: "https://kontentutorialmpstore-cdn.maduraprime.com/85c807ba-035e-49be-bdb0-664a2d1f0afa.png" },
    { name: "Bintang Emon", logoUrl: "https://kontentutorialmpstore-cdn.maduraprime.com/69e8f82a-cb25-4be3-afbf-c03fec384ed0.png" },
    // DIUBAH: Menambahkan logoUrl sesuai permintaan Anda
    {
      name: "MPIX By The Basecamp",
      logoUrl: "https://kontentutorialmpstore-cdn.maduraprime.com/834a610d-bf3b-4e1e-b3e8-43de66f80b8c.png"
    },
    { name: "PayAccess", logoUrl: "https://kontentutorialmpstore-cdn.maduraprime.com/621eaa9c-1da1-43ce-a6e2-7bf2eff5679d.png" }
  ]
};

export const ctaSection = {
  title: "Join the E-commerce Revolution",
  subtitle: "Discover how MPStore Business Solution empowers merchants with powerful tools for online success.",
  cta: "Get Started Now",
  bottomText: "Join thousands of businesses thriving with us.",
  image: "https://cdn.prod.website-files.com/6909add2e2d94f386f984495/6909b053ac74f308f11f2e3f_Wide%20Main%2003.png"
};

export const features = {
  mainTitle: " E-commerce Solutions",
  mainSubtitle: "Explore our all-in-one platform tailored for online store success, focusing on ease and efficiency for businesses of all sizes.",
  items: [
    {
      image: "https://kontentutorialmpstore-cdn.maduraprime.com/38d83517-ea2f-4b31-94b1-64e30e30853e.png",
      title: "Effortless Payment Systems",
      description: "Secure and swift payment integrations made simple for your business."
    },
    {
      image: "https://kontentutorialmpstore-cdn.maduraprime.com/3834908c-f9ef-45cd-81ec-6169bff5aef7.png",
      title: "Streamlined Inventory Management",
      description: "Easily manage and track your products with our intuitive inventory features designed for efficiency."
    },
    {
      image: "https://kontentutorialmpstore-cdn.maduraprime.com/1a818b09-166c-4785-9ec4-e1f7b2aab5a8.png",
      title: "Reliable Shipping Solutions",
      description: "Fast shipping options integrated seamlessly to enhance your customer experience."
    }
  ]
};

export const detailedFeatures = {
  badge: "Features",
  title: "Empower Your Store Today",
  subtitle: "Discover the essential tools to launch your e-commerce site.",
  items: [
    {
      category: "Customization",
      title: "Drag-and-Drop Store Builder",
      tagline: "Easily create your online store with our intuitive editor.",
      features: [
        "Create a stunning storefront in minutes without coding.",
        "Choose from vibrant responsive themes that fit your brand.",
        "Customize checkout processes to enhance customer experience."
      ],
      image: "https://cdn.prod.website-files.com/6909add2e2d94f386f984495/6909b054ac74f308f11f2ed6_Features%201.avif"
    },
    {
      category: "AI Optimization",
      title: "AI Store Keeper",
      tagline: "Let our AI Manage and optimize your store 24/7.",
      features: [
        "Automatically optimize product descriptions and pricing for maximum conversion.",
        "AI-driven inventory analysis to predict demand and prevent stockouts.",
        "Personalized customer recommendations and support powered by machine learning."
      ],
      image: "https://kontentutorialmpstore-cdn.maduraprime.com/fe2b7e52-4f7c-40e4-b9e7-9a13246afbbb.jpg"
    }
  ]
};

export const stats = {
  badge: "Performance Insights",
  title: "Unlock Your E-commerce Potential Today",
  subtitle: "Join thousands of merchants achieving incredible results with ease.",
  items: [
    { value: "5,000+", label: "Capture over five thousand merchants succeeding through our user-friendly platform." },
    { value: "99.95%", label: "Experience unparalleled uptime at 99.95% for reliable service delivery." },
    { value: "38%", label: "Increase sales with 38% boost from our 1-click checkout feature." },
    { value: "1-click", label: "Utilize our 1-click checkout to enhance conversions effortlessly." }
  ],
  backgroundImage: "https://kontentutorialmpstore-cdn.maduraprime.com/e5e883a1-005a-4244-a4ad-ddbe92c4b9a3.jpg"
};

export const integrations = {
  badge: "Explore Our Integrations",
  title: "Seamless Integration Solutions",
  subtitle: "Discover a variety of integrations that enhance your store's functionality and streamline your operations quickly. Enjoy fast setup with essential tools.",
  description: "From payment gateways to shipping solutions, our integrations are designed to maximize your workflow efficiency and ensure smooth operations across all platforms.",
  bottomTitle: "Integrate Effortlessly Today",
  images: [
    "https://cdn.prod.website-files.com/6909add2e2d94f386f984495/6909b053ac74f308f11f2df6_iPhone%2014%20Pro.png",
    "https://cdn.prod.website-files.com/6909add2e2d94f386f984495/6909b053ac74f308f11f2e17_Mobile%202.avif"
  ]
};

export const pricing = {
  badge: "Choose your perfect plan",
  title: "Affordable Pricing for Everyone",
  subtitle: "Explore our pricing options designed for all businesses, big or small.",
  plans: [
    // {
    //   name: "Basic",
    //   price: 10,
    //   period: "month",
    //   description: "Simple pricing with no hidden fees for your convenience.",
    //   features: [
    //     "Unlimited product listings",
    //     "24/7 customer support",
    //     "Secure payment processing",
    //     "Mobile-friendly design"
    //   ],
    //   cta: "Get Started",
    //   secondaryCta: "Contact Sales",
    //   image: "https://cdn.prod.website-files.com/6909add2e2d94f386f984495/6909b053ac74f308f11f2e8a_Abstract%20image%2001.png"
    // },
    {
      name: "Enterprise",
      price: "Let's Talk",
      period: null,
      description: "For ambitious businesses ready to scale — let's discuss your custom plan.",
      features: [
        "Custom integrations & automation",
        "Priority onboarding",
        "Flexible pricing options",
        "Dedicated success manager"
      ],
      cta: "Contact Us  ",
      secondaryCta: "Chat for details",
      image: "https://kontentutorialmpstore-cdn.maduraprime.com/11489eca-497c-4c93-b084-eb80033a1611.jpg",
      popular: true
    },
    // {
    //   name: "Enterprise",
    //   price: 50,
    //   period: "month",
    //   description: "Tailored pricing for high-volume businesses and custom needs.",
    //   features: [
    //     "Dedicated account manager",
    //     "Custom API integrations",
    //     "Premium resources and support",
    //     "Unlimited storage for products"
    //   ],
    //   cta: "Join Us",
    //   secondaryCta: "Contact Sales",
    //   image: "https://cdn.prod.website-files.com/6909add2e2d94f386f984495/6909b054ac74f308f11f2ea2_Abstract%20Image.avif"
    // }
  ]
};

export const cardNavItems = [
  {
    label: "Products",
    bgColor: "#111111", // Warna gelap
    textColor: "#fff",
    links: [
      { label: "Features", href: "#features", ariaLabel: "View Features" },
      { label: "Integrations", href: "#integrations", ariaLabel: "View Integrations" }
    ]
  },
  {
    label: "Navigate",
    bgColor: "#222222", // Sedikit lebih terang
    textColor: "#fff",
    links: [
      { label: "Home", href: "#hero", ariaLabel: "Go to Home" },
      { label: "Pricing", href: "#pricing", ariaLabel: "View Pricing" }
    ]
  },
  {
    label: "Support",
    bgColor: "#333333", // Paling terang
    textColor: "#fff",
    links: [
      { label: "FAQ", href: "#faq", ariaLabel: "Read FAQ" },
      { label: "Testimonials", href: "#testimonials", ariaLabel: "Read Testimonials" }
    ]
  }
];

export const testimonials = {
  badge: "Customer Testimonials",
  title: "Join Our Thriving E-Commerce Community Today",
  subtitle: "Discover how our platform empowers entrepreneurs to launch their online stores effortlessly.",
  items: [
    {
      quote: "TokoSprint made my online store setup incredibly simple and fast!",
      author: "Alex Taylor",
      role: "E-commerce Manager",
      avatar: "https://cdn.prod.website-files.com/6909add2e2d94f386f984495/6909b054ac74f308f11f2eaf_Team%20Image.avif"
    },
    {
      quote: "The support team is always there to help when needed!",
      author: "Jordan Casey",
      role: "Customer Success",
      avatar: "https://cdn.prod.website-files.com/6909add2e2d94f386f984495/6909b054ac74f308f11f2eb8_Team%20Person%20Image%206.avif"
    },
    {
      quote: "I launched my store in just hours, thanks to TokoSprint!",
      author: "Sam Morgan",
      role: "Marketing Specialist",
      avatar: "https://cdn.prod.website-files.com/6909add2e2d94f386f984495/6909b054ac74f308f11f2ec1_Team%20Person%20Image%204.avif"
    },
    {
      quote: "Fast and reliable, TokoSprint exceeded my expectations for e-commerce!",
      author: "Skyler Lee",
      role: "Product Designer",
      avatar: "https://cdn.prod.website-files.com/6909add2e2d94f386f984495/6909b054ac74f308f11f2ec1_Team%20Person%20Image%204.avif"
    }
  ]
};

export const faq = {
  title: "Frequently Asked Questions",
  subtitle: "Find answers to common questions about getting started and billing.",
  items: [
    {
      question: "How do I get started with MPStore Enterprise?",
      answer: "Every business is unique. Chat with our team to find the best setup for you."
    },
    {
      question: "Can I get a custom plan for my business?",
      answer: "Absolutely! Contact us and we’ll tailor a plan that fits your needs."
    },
    {
      question: "What are the pricing options for Enterprise?",
      answer: "Pricing depends on your business scale and requirements. Let’s discuss it together — just chat with us."
    },
    {
      question: "How long does the setup process take?",
      answer: "It’s fast and flexible! Message us to see how quickly we can get your store running."
    },
    {
      question: "Can I upgrade from another plan to Enterprise?",
      answer: "Of course! Reach out to our team and we’ll guide you through the transition."
    }
  ],
  image: "https://cdn.prod.website-files.com/6909add2e2d94f386f984495/6909b053ac74f308f11f2e6c_About%201.avif"
};

export const finalCta = {
  title: "Our Partnership Payments and Shipping Solutions",
  subtitle: "Experience a hassle-free setup to start selling quickly and easily.",
  cta: "Dont Forget to Get Started",
  features: [
    {
      title: "Unmatched Features",
      description: "All the tools you need for success."
    },
    {
      title: "Exceptional Support",
      description: "Expert help available 24/7 for your convenience."
    },
    {
      title: "Flexible Pricing",
      description: "Choose a plan that fits your business needs."
    }
  ],
  image: "https://cdn.prod.website-files.com/6909add2e2d94f386f984495/6909b053ac74f308f11f2e0e_Main%20Dashboard%20.avif"
};

export const footer = {
  logo: "Business Solution",
  sections: [
    {
      title: "Quick Links",
      links: [
        { label: "About Us", href: "https://mpstore.co.id/" },
        { label: "Blog", href: "https://mpstore.co.id/" },
        { label: "Support", href: "https://mpstore.co.id/contact-us/" },
        { label: "Contact", href: "https://mpstore.co.id/contact-us/" }
      ]
    },
    {
      title: "Resources",
      links: [
        { label: "Help Center", href: "https:/wa.me/6282334536656" },
        { label: "Pricing", href: "https:/wa.me/6282334536656" },
        { label: "Documentation", href: "https://mpstore.co.id/" },
        { label: "Privacy Policy", href: "https://mpstore.co.id/privacy/" }
      ]
    },
    {
      title: "Connect",
      links: [
        { label: "Facebook", href: "https://www.facebook.com/mpstoresuperapp/" },
        { label: "Twitter", href: "#" },
        { label: "Instagram", href: "https://www.instagram.com/mpstore_superappumkm/" },
        { label: "LinkedIn", href: "https://www.linkedin.com/company/pt-mitra-pedagang-indonesia-tbk/posts/?feedView=all" }
      ]
    },
    {
      title: "Follow Us",
      links: [
        { label: "Your Updates", href: "https://mpstore.co.id/services/" },
        { label: "E-commerce Tips", href: "https://mpstore.co.id/services/" },
        { label: "New Features", href: "https://mpstore.co.id/services/" },
        { label: "Product News", href: "https://mpstore.co.id/services/" }
      ]
    }
  ],
  cards: [
    {
      title: "Explore Affordable E-commerce Solutions",
      description: "Unlock the potential of your online business with our streamlined services and unmatched support.",
      cta: "Learn More"
    },
    {
      title: "Elevate Your Brand Experience",
      description: "Transform your online presence with our powerful tools designed for growth and success.",
      cta: "Discover More"
    }
  ],
  copyright: "© 2025 MPStore Business Solution. All rights reserved. Terms of service and privacy policy apply.",
  bottomLinks: [
    { label: "FAQ", href: "" },
    { label: "Careers", href: "#" },
    { label: "Press", href: "https://mpstore.co.id/" },
    { label: "Partnerships", href: "https://mail.google.com/mail/?view=cm&fs=1&to=aad@mpstore.co.id&su=[PARTNERSHIPS] MPStore Bussiness Solution" }
  ],
  socials: ["instagram", "linkedin", "twitter"]
};
